import ConnectedSearchInput from './search-input-connected.jsx';

export default ConnectedSearchInput;
